import { useIsSmallViewportWidth } from 'hooks/use-is-small-viewport-width.hook';
import { useFilteringEnabled } from 'hooks/use-filtering-enabled.hook';
import { useResourceLoadingHandler } from 'pages/resources/hooks';
import { useCallback, useMemo } from 'react';
import { goBack, push } from 'store/router/actions';
import { resetResourcesState } from 'store/resources/actions';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { LANDING_PATH } from 'shared/consts';

interface UseHeaderReturnValues {
  isHeaderVisible: boolean;
  onPressBack: VoidFunction;
  onMyBookingsClick: VoidFunction;
}

export const useHeader = (): UseHeaderReturnValues => {
  const dispatch = useDispatch();
  const { pathname, search } = useLocation();
  const isMobileDevice = useIsSmallViewportWidth();
  const isFilteringEnabled = useFilteringEnabled();
  const isLoadingState = useResourceLoadingHandler(isFilteringEnabled);
  const isHeaderVisible = useMemo<boolean>(() => !isMobileDevice && !isLoadingState, [isLoadingState, isMobileDevice]);

  const pathnameForPushAction = useMemo(
    () => (pathname === LANDING_PATH ? `bookings${search}` : `${pathname}/bookings${search}`),
    [pathname, search],
  );

  const onPressBack = useCallback(() => {
    dispatch(goBack());
    dispatch(resetResourcesState());
  }, [dispatch]);

  const onMyBookingsClick = useCallback(() => {
    dispatch(push(pathnameForPushAction));
  }, [dispatch, pathnameForPushAction]);

  return {
    isHeaderVisible,
    onPressBack,
    onMyBookingsClick,
  };
};
